<template>
  <div class="text-center" :class="{full}">
    <div v-if="full">
      <img src="../../assets/logo-light.png" class="d-block m-auto" alt="Logo Lecard" style="max-width: 168px;">
      <div class="text-white mt-2" v-if="text && text !== true" style="white-space: break-spaces;">{{text}}</div>
    </div>
    <div v-else>
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      <div class="small mt-2" v-if="text && text !== true">{{text}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Loading",
    props: ['full', 'text', 'logo']
  }
</script>

<style scoped>
  .full {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--primary);
  }
</style>
